<template>
<div class="audit-ion-device-compare-chart-wrapper">
  <el-tabs v-model="tabActiveName" type="card" @tab-click="tabChange">
    <el-tab-pane
      v-for="tabOpt in tabOpts"
      :key="tabOpt.name"
      :label="tabOpt.label"
      :name="tabOpt.name"
    />
  </el-tabs>

  <div style="border:1px solid #E4E7ED;border-top:0;padding: 0;overflow:auto;">
    <audit-key-parameter-chart
      v-if="tabActiveName === 'keyParameter'"
      :query="statusQuery"
      :data="statusData"
      :importance-device-status-map="importanceDeviceStatusMap"
    />
    <Component
      v-else
      :is="currentTab.is"
      :filter-sites="otherFilterSites"
      :query="query"
      :data-list="currentTab.data"
      @query-site-ids-changed="onSearchBtnClick"
    />
  </div>
</div>
</template>

<script>
import BaseCompare from './BaseCompare'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'
import DataFormatter from '../../../../model/DataFormatter'

import Pm25IonChart from './Pm25IonChart'
import YinYangRelatedChartGroupWrapper from './YinYangRelatedChartGroupWrapper'
import AuditKeyParameterChart from './AuditKeyParameterChart'

export default {
  name: 'AuditIonDeviceCompareChart',
  extends: BaseCompare,
  components: {Pm25IonChart, YinYangRelatedChartGroupWrapper, AuditKeyParameterChart},
  props: {
    auditDataList: {
      required: true,
      type: Array
    },
    auditQuery: {
      required: true,
      type: Object
    },
    auditSiteDevice: {
      required: true,
      type: Object
    },
    importanceDeviceStatus: {
      required: true,
      type: Array
    },
    importanceDevicesMap: {
      required: true,
      type: Object
    },
    importanceDeviceStatusMap: {
      required: true,
      type: Object
    },
    conditions: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    tabActiveName: 'PM2.5Ion',
    yinYangDataList: Object.freeze([]),
    statusQuery: {},
    statusData: []
  }),
  computed: {
    completeAllData: () => true,
    otherSiteDeviceCategoryConfigs: () => [
      new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false, siteDeviceFactors => siteDeviceFactors.filter(siteDeviceFactor => siteDeviceFactor.factorId === '1008'))
    ],
    tabOpts () {
      let tabOpts = [{
        name: 'PM2.5Ion',
        label: 'PM2.5与离子组分',
        is: 'pm25-ion-chart',
        data: this.dataList
        // query: this.pm25IonQuery
      }, {
        name: 'yinYang',
        label: '阴阳离子平衡',
        is: 'yin-yang-related-chart-group-wrapper',
        data: this.yinYangDataList
        // query: this.yinYangQuery
      }]

      let {auditSiteDevice, importanceDevicesMap} = this
      if (this.importanceDeviceStatus.length > 0 && importanceDevicesMap[auditSiteDevice.id]) {
        tabOpts.unshift({
          name: 'keyParameter',
          label: '状态关键参数'
        })
      }

      return tabOpts
    },
    currentTab () {
      let {tabActiveName} = this
      return this.tabOpts.find(tabOpt => tabOpt.name === tabActiveName)
    },
    otherFilterSites () {
      let siteId = this.site.id
      return this.filterSites.filter(site => site.id !== siteId)
    }
  },
  methods: {
    tabChange () {
      if (this.tabActiveName === 'keyParameter') {
        let {auditSiteDevice, conditions: {beginTime, endTime}, auditQuery: {siteId}, importanceDevicesMap} = this
        let queryData = {
          siteIds: [siteId],
          beginTime,
          endTime,
          statusIds: importanceDevicesMap[auditSiteDevice.id].map(el => el.deviceStatusId)
        }

        this.changeLoadStatus(true)
        this.$api.StatusData.getKeyParameter(queryData).then(data => {
          this.statusData = Object.freeze(data)
          this.statusQuery = queryData
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      }
    },
    getSeriesParam (dimension, dimensionIds) {
      let factorId = dimensionIds[dimension ^ 1]

      if (factorId === '1008') {
        return {
          type: 'line',
          showSymbol: false
        }
      } else {
        let siteId = dimensionIds[dimension]
        let param = {
          type: 'bar',
          stack: siteId,
          barMaxWidth: 30,
          showSymbol: false,
          areaStyle: {}
        }

        return param
      }
    },
    // 不显示tool的站点 从此之后注释掉
    dataFormatter: DataFormatter.format2,
    formatData () {
      this.dataFormatter()
      let data = {
        id: 'PM25-ION',
        name: 'PM2.5与离子组分',
        dataTimes: this.totalDataTimes,
        ...this.dataList.reduce((data, dataConfig) => {
          let {id, name, dimensions, seriesMap} = dataConfig
          let dimensionsLen = dimensions.length
          let {dimensions: newDimensions, seriesMap: newSeriesMap, selectedNames} = data

          for (let i = 0; i < dimensionsLen; i++) {
            let dimension = dimensions[i]
            let dimensionId = dimension.id
            let newId = `${id}-${dimensionId}`
            let newName = `${name}-${dimension.name}`

            newDimensions.push({
              ...dimension,
              id: newId,
              name: newName
            })

            newSeriesMap[newId] = seriesMap[dimensionId]
            selectedNames[newName] = !/_G$/i.test(newName)
          }

          return data
        }, {
          dimensions: [],
          seriesMap: {},
          selectedNames: {}
        })
      }

      this.dataList = Object.freeze([data])
    }
  },
  watch: {
    auditDataList: {
      immediate: true,
      handler (auditDataList) {
        this.auditDataList1 = this.auditDataList.reduce((list, data) => {
          if (data.auditFlag !== 'DELETE') {
            list.push({
              ...data,
              value: data.dasValue
            })
          }
          return list
        }, [])
        this.dataFormatter('auditDataList1', 'yinYangDataList')
      }
    }
  }
}
</script>

<style lang="scss">
.audit-ion-device-compare-chart-wrapper {
  --width: 518px;

  display: grid;
  grid-template-rows: max-content auto;
  width: 100%;
  height: 100%;
  background-color: #ffffff;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  .el-tabs__header {
    margin-bottom: 0;
  }

  .yin-yang-charts-wrapper {
    grid-template: {
      columns: auto;
      rows: auto calc(var(--width) - 62px);
    };

    /deep/ > .yin-yang-related-chart-wrapper {
      grid-template-rows: 40px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditDeviceViews/AuditIonDeviceCompareChart.vue